import React from 'react'
import { withRouter } from 'react-router-dom';
import {Box,Card,CardHeader, CardBody, Text,DataTable, CardFooter,Button,Tag,Tip } from 'grommet';
import { Deliver,Alert,Refresh } from 'grommet-icons';
import { NavigationSnackBar, QuoteData, ReturnRowDir } from '../../components/utils/shared/shared';
import {ReturnQuoteLocation} from '../../components/utils/shared/shipmentViewFunctions'
import ShipmentQuoteBreakdown from '../../components/quoteBreakdown';

function returnTransitDetails(quote,quoteData,columns){
    return (
        <Card pad='medium' background={'background-front'} round gap="small"  hoverIndicator margin={'small'} style={{minWidth:900}}>
             <CardHeader justify='start'>
                <Deliver color='brand'/><Text size="medium">Transit Details</Text>
            </CardHeader>
            <CardBody margin='small'>
            <Box direction='row' margin='xsmall'>
                 <Tip plain content={<Box direction='row' elevation='large' margin='medium' pad="small" gap="small" width={{ max: 'large' }} round background="white"><Alert color='status-warning' /><Text margin={{top:'xxsmall'}} weight='bold' size='small'>Please note transit times are an estimate, actual delivery times may vary.</Text></Box>}>
                <Tag pad='small'  background='brand' size='small' name="Estimated Transit Time" value={`${quote.transit_time} days`} />
                </Tip>
                </Box>
            <DataTable margin='small'background={{header: { color: '#18445C' }}} border={{"body":"bottom"}} columns={columns} data={quoteData}/>
            {returnBillableWeight(quote)}
            </CardBody>
            <CardFooter>
            <Tip plain content={<Box direction='row' elevation='large' margin='medium' pad="small" gap="small" width={{ max: 'large' }} round background="white"><Alert color='status-warning' /><Text margin={{top:'xxsmall'}} weight='bold' size='small'>Please note this is an approximate quote based on the weight and dimensions provided. The final total may be subject to additional duties and taxes.</Text></Box>}><Text weight={'bold'} >Quote: $ {quote.total_quote_price} {quote.total_quote_price_currency}</Text></Tip>
            </CardFooter>
        </Card>
    )
}

function returnBillableWeight(quote){
    if (quote.quoted_weight > quote.total_actual_weight){
        return (
            <Text size='small'>Billable Weight: {quote.quoted_weight} KG (Volumetric Weight)</Text>
        )
    } else {
        return (
            <Text size='small'>Billable Weight: {quote.quoted_weight} KG</Text>
        )
    }
}

function QuoteCard(props) {
  const quote = props.location.state.quote
  const columns =  [{primary:true,property: 'Weight',header:"Weight", units: "(KG)"},{property: 'Length',header: "Length", units: "(CM)"},{property: 'Width',header: "Width", units: "(CM)"},{property: 'Height',header: "Height", units: "(CM)"}]
  return (
      <Box background={'light-1'}>
        <NavigationSnackBar title='Quote Summary' user={props.user} pages={[{name: 'Dashboard', link:'/dashboard'},{name: 'Create Quote', link: '/quote/new'}]}  />
        <Box direction='column' justify="center" margin='small'>
            <CardBody>
                <Box direction={ReturnRowDir(props.size)} alignSelf='center' margin='small' gap='medium'>
                <ReturnQuoteLocation location={quote.quote.origin} locationType={"Origin"} />
                <ReturnQuoteLocation location={quote.quote.destination} locationType={"Destination"} />
                </Box>
                <Box direction='row' alignSelf='center' margin='small'>
                {returnTransitDetails(quote.quote,QuoteData(quote),columns)}
                </Box>
                {(props.user === 'SuperAdmin' ? <Box background={'background-front'} elevation='medium' round margin={'small'} pad='small'><ShipmentQuoteBreakdown shipment={quote} /></Box> : null)}
            </CardBody>
            <CardFooter justify='start' direction='row' margin='small' pad='small'>
                <Button label='Try Again' icon={<Refresh color='brand'/>} color='brand' onClick={() => props.history.push({pathname: '/quote/new', data: quote, requote:true})} />
            </CardFooter>
    </Box>
    </Box>
  )
}

export default withRouter(QuoteCard)
